import React, { useState, useEffect } from "react";
import _ from "lodash";

import Footer from "./Footer";
import FooterNew from "./FooterNew";
import HeaderNewMenu from "./HeaderNewMenu";
import HeaderSearch from "./HeaderSearch";
import Loader from "../components/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import {
  setShowDropDown,
  setShowMoreMenuReq,
} from "../redux/assignCourse/actions";
import { SessionKeys } from "../utils/AppUtils";
import FooterNewB2C from "./FooterNewB2C";
import SmartBarSection from "./SmartBarSection";
import { getSmartBar } from "../redux/home/actions";
import useLogin from "../custom-hooks/useLogin";

const Page = (props) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = React.useState(true);
  const [smartBarData, setSmartBarData] = useState();
  const showDropDownRes = useSelector(
    (state) => state.assignCourse.showDropDownRes
  );
  const showMoreMenuRes = useSelector(
    (state) => state.assignCourse.showMoreMenuRes
  );
  const authBroker = useSelector((state) => state.auth.authBroker);
  const getSmartBarResponse = useSelector((state) => state.home.smartBar);
  const userRole = useSelector((state) => state.user.role)
  const { isLoggedIn } = useLogin();

  const [config,setConfig] = useState({});

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
        console.log("authBroker: ",authBroker)
        if (!_.isEmpty(authBroker.payload.user.role)) {
            setConfig(authBroker.payload.user.config)
        }else{
          setConfig({})
        }
    }else{
      setConfig({})
    }
}, [authBroker])

  useEffect(() => {
    if (!_.isEmpty(getSmartBarResponse)) {
      setIsLoading(false);
      if (getSmartBarResponse.status === "success") {
        setSmartBarData(getSmartBarResponse?.payload?.payload);
      }
    }
  }, [getSmartBarResponse]);



  return (
    <div id='idForTour' className="page-wrapper-rsp">
     {false &&<Loader start={isLoading} setIsLoading={setIsLoading} />}
      <div
        id="idParent"
        className="rspinnerwrapper"
        onClick={() => {
          if (
            (showDropDownRes === true &&
              sessionStorage.getItem(SessionKeys.IS_TOUR) === "NO") ||
            (showDropDownRes === true &&
              sessionStorage.getItem(SessionKeys.IS_TOUR) === null)
          ) {
            dispatch(setShowDropDown(false));
          }
          if (
            (showMoreMenuRes === true &&
              sessionStorage.getItem(SessionKeys.IS_TOUR) === "NO") ||
            (showMoreMenuRes === true &&
              sessionStorage.getItem(SessionKeys.IS_TOUR) === null)
          ) {
            dispatch(setShowMoreMenuReq(false));
          }
        }}
      >
        {/* <HeaderSearch />  localStorage.getItem(SessionKeys.SHOW_LEADERBOARD)!=="false" */}
        <HeaderNewMenu showMenu={true} />
        {(config?.banner_strip !== "false" && smartBarData?.display_prompt!== false) &&(userRole === 'customer' || !isLoggedIn ) && <SmartBarSection smartBarData={smartBarData} isLoading={isLoading}/>}
        {/* <HeaderMenu /> */}
        {props.children}
      </div>
      {/* <Footer /> */}
      {!props.hideFooter && <FooterNewB2C />}
    </div>
  );
};

export default Page;
